import { createSvgIcon } from '@mui/material';

export const CopyToClipboard = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M15.5 6.75C16.4664 6.75017 17.25 7.5336 17.25 8.5V19.0996C17.25 20.066 16.4664 20.8494 15.5 20.8496H4.90039C3.93389 20.8496 3.15039 20.0661 3.15039 19.0996V8.5C3.15039 7.5335 3.93389 6.75 4.90039 6.75H15.5ZM4.90039 8.25C4.76232 8.25 4.65039 8.36193 4.65039 8.5V19.0996C4.65039 19.2377 4.76232 19.3496 4.90039 19.3496H15.5C15.6379 19.3494 15.75 19.2376 15.75 19.0996V8.5C15.75 8.36203 15.6379 8.25017 15.5 8.25H4.90039ZM19.0996 3.15039C20.0661 3.15039 20.8496 3.93389 20.8496 4.90039V15.5C20.8494 16.4664 20.066 17.25 19.0996 17.25H18.5254V15.75H19.0996C19.2376 15.75 19.3494 15.6379 19.3496 15.5V4.90039C19.3496 4.76232 19.2377 4.65039 19.0996 4.65039H8.5C8.36193 4.65039 8.25 4.76232 8.25 4.90039V5.47559H6.75V4.90039C6.75 3.93389 7.5335 3.15039 8.5 3.15039H19.0996Z"
      fill="currentColor"
    />
  </svg>,
  'CopyToClipboard',
);
